/**
 * realtime.service.js
 * Ponto de entrada unificado para o Realtime do MyTriad.
 * Exporta o TransportManager que roteia entre Ably (Nuvem) e WebRTC (LAN Local).
 */

import { transportManager } from './realtime/transport.manager';

export const realtimeService = transportManager;
export default realtimeService;
